import React from 'react';

import RangeSlider from '../../../RangeSlider';

interface RateSliderGroupProps {
	rateValue: number;
	feeValue: number;
	onRateChange: (value: number) => void;
	onFeeChange: (value: number) => void;
	rateLabel?: string;
	feeLabel?: string;
	showReadOnly?: boolean;
}

export const RateSliderGroup: React.FC<RateSliderGroupProps> = ({
	rateValue,
	feeValue,
	onRateChange,
	onFeeChange,
	rateLabel = 'Discount Rate',
	feeLabel = 'Authorization Fee',
	showReadOnly = false,
}) => {
	// Safety check: ensure values are valid numbers
	const safeRateValue =
		typeof rateValue === 'number' && !isNaN(rateValue) ? rateValue : 0;
	const safeFeeValue =
		typeof feeValue === 'number' && !isNaN(feeValue) ? feeValue : 0;

	if (showReadOnly) {
		return (
			<>
				<div className="text-center">
					<div className="flex items-center justify-center">
						<span className="text-yellow-600 mr-1">%</span>
						<span className="text-purple-600 font-medium">
							{safeRateValue.toFixed(2)}
						</span>
					</div>
					<div className="text-xs text-gray-500 mt-1">{rateLabel}</div>
				</div>
				<div className="text-center">
					<div className="flex items-center justify-center">
						<span className="text-green-600 mr-1">$</span>
						<span className="text-purple-600 font-medium">
							{safeFeeValue.toFixed(2)}
						</span>
					</div>
					<div className="text-xs text-gray-500">{feeLabel}</div>
				</div>
			</>
		);
	}

	return (
		<>
			<div className="space-y-2 col-span-2">
				<RangeSlider
					label={rateLabel}
					value={safeRateValue}
					onChange={onRateChange}
					min={0}
					max={5}
					step={0.01}
					unit="%"
					precision={2}
				/>
			</div>
			<div className="space-y-2 col-span-2">
				<RangeSlider
					label={feeLabel}
					value={safeFeeValue}
					onChange={onFeeChange}
					min={0}
					max={1}
					step={0.01}
					unit="$"
					precision={2}
				/>
			</div>
		</>
	);
};
